/* kb-recs.js: rendert aanbevelingsblokken ([data-kb-placement]) vanuit de eigen API,
   met terugval binnen 600 ms op Shopify's /recommendations/products.json (productpagina) of verbergen.
   Meet impressies (50 procent zichtbaar) en kliks, en ververst de drawer-upsell bij cartwijzigingen. */
(function () {
  'use strict';
  var C = window.KBREC;
  if (!C || !C.api) return;
  var TIMEOUT = 600; // was 300; verhoogd 7 oktober 2026: skelet staat er toch, een leeg blok kost meer dan 300 ms extra wachten
  var tpl = null, skel = null;

  function money(n) {
    if (n === null || n === undefined) return '';
    var s = Number(n).toFixed(2).replace('.', ',');
    var f = (C.money && C.money.format) || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function fetchTimeout(url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, mode: 'cors', credentials: 'omit' })
      .then(function (r) { clearTimeout(t); if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function prefix() { return C.localePrefix === '/' ? '' : (C.localePrefix || ''); }

  /* Shopify-terugval: zelfde kaartvorm als de API. */
  function fallback(placement, limit) {
    if (!C.product) return Promise.resolve(null);
    var intent = placement === 'pdp_routine' || placement === 'cart_upsell' ? 'complementary' : 'related';
    return fetchTimeout(prefix() + '/recommendations/products.json?product_id=' + C.product.id + '&limit=' + Math.min(limit, 10) + '&intent=' + intent, 2000)
      .then(function (j) {
        return {
          placement: placement, fallback: true, request_id: null, title: null, subtitle: null,
          products: (j.products || []).map(function (p) {
            return { id: p.id, handle: p.handle, url: p.url, title: p.title, vendor: p.vendor, image: p.featured_image,
              price: p.price / 100, compare_at_price: p.compare_at_price ? p.compare_at_price / 100 : null, available: p.available, label: null, reason: '' };
          })
        };
      }).catch(function () { return null; });
  }

  function load(el) {
    var placement = el.getAttribute('data-kb-placement');
    var limit = parseInt(el.getAttribute('data-kb-limit') || '8', 10);
    var vis = window.KBTrack ? window.KBTrack.visitor() : null;
    var q = 'placement=' + encodeURIComponent(placement) + '&locale=' + C.locale + '&limit=' + limit;
    if (C.product) q += '&product=' + C.product.id;
    if (vis) q += '&visitor=' + vis;
    if (C.collection) q += '&collection=' + encodeURIComponent(C.collection);
    var cart = (window.KBTrack ? window.KBTrack.cart() : C.cart) || [];
    if (cart.length) q += '&cart=' + cart.map(function (i) { return i.product_id; }).join(',');
    if (placement === 'home_recent') {
      var recent = window.KBTrack ? window.KBTrack.recent() : [];
      // "Wissen" verbergt het blok tot er weer een product bekeken wordt (kb-track wist dan de vlag).
      var cleared = false; try { cleared = localStorage.getItem('kb_recent_cleared') === '1'; } catch (e) {}
      if (cleared || (!vis && !recent.length)) { el.hidden = true; return; }
    }
    showSkeleton(el, Math.min(limit, 6));
    fetchTimeout(C.api + '/recs?' + q, TIMEOUT)
      .catch(function () { return fallback(placement, limit); })
      .then(function (data) { render(el, data); });
  }

  function showSkeleton(el, n) {
    if (!skel) return;
    var list = el.querySelector('.kb-recs__list');
    list.innerHTML = '';
    for (var i = 0; i < n; i++) list.appendChild(skel.content.cloneNode(true));
    el.hidden = false;
    var tEl = el.querySelector('.kb-recs__title');
    if (tEl) tEl.textContent = el.getAttribute('data-kb-title') || ' ';
  }

  var VIRAL = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.5 3c.4 2.3 1.8 3.8 4 4v3.2c-1.5 0-2.9-.5-4-1.3v6.3a5.7 5.7 0 1 1-4.9-5.6v3.3a2.5 2.5 0 1 0 1.7 2.3V3h3.2z"/></svg>';
  function str(k, d) { return (C.strings && C.strings.card && C.strings.card[k]) || d; }

  /* Vult een gekloonde kaart-template met een product (ook gebruikt door kb-search.js). */
  function fill(node, p) {
    var li = node.querySelector('.kbr-card');
    li.setAttribute('data-kb-id', p.id);
    node.querySelectorAll('a').forEach(function (a) { a.href = p.url; });
    var img = node.querySelector('.kbr-card__img');
    // Zonder afbeelding geen kapotte img met alt-tekst, maar een lege vlakke kaartfoto.
    if (p.image) { img.src = sized(p.image, 400); img.alt = p.title; }
    else { img.removeAttribute('src'); img.alt = ''; img.hidden = true; li.classList.add('kbr-card--noimg'); }
    var label = node.querySelector('.kbr-card__label');
    if (p.label) {
      label.hidden = false;
      label.className += ' kbr-card__label--' + p.label;
      if (p.label === 'viral') label.innerHTML = VIRAL;
      label.appendChild(document.createTextNode((C.strings.labels || {})[p.label] || p.label));
    }
    var sale = p.compare_at_price && p.price && p.compare_at_price > p.price;
    if (sale) { var d = node.querySelector('.kbr-card__discount'); d.hidden = false; d.textContent = '−' + Math.round((1 - p.price / p.compare_at_price) * 100) + '%'; }
    node.querySelector('.kbr-card__reason').textContent = p.reason || '';
    node.querySelector('.kbr-card__vendor').textContent = p.vendor || '';
    node.querySelector('.kbr-card__title').textContent = p.title;
    if (p.rating > 0) {
      var r = node.querySelector('.kbr-card__rating');
      r.hidden = false;
      node.querySelector('.kbr-card__score').textContent = Number(p.rating).toFixed(1).replace('.', ',');
      node.querySelector('.kbr-card__stars-fill').style.width = Math.min(100, p.rating / 5 * 100) + '%';
      node.querySelector('.kbr-card__count').textContent = p.rating_count ? '(' + p.rating_count + ')' : '';
      r.setAttribute('aria-label', String(p.rating).replace('.', ',') + ' / 5');
    }
    var stock = node.querySelector('.kbr-card__stock');
    if (p.available === false) { stock.textContent = str('sold_out', 'Uitverkocht'); stock.className += ' kbr-card__stock--out'; }
    else if (p.low_stock) { stock.textContent = str('low_stock', 'Bijna uitverkocht'); stock.className += ' kbr-card__stock--low'; }
    else stock.textContent = str('in_stock', 'Op voorraad');
    node.querySelector('.kbr-card__price-now').textContent = money(p.price);
    var was = node.querySelector('.kbr-card__price-was');
    if (sale) { was.hidden = false; was.textContent = money(p.compare_at_price); node.querySelector('.kbr-card__price').className += ' kbr-card__price--sale'; }
    var btn = node.querySelector('.kbr-card__add');
    btn.textContent = str('add', 'Toevoegen');
    btn.setAttribute('aria-label', str('add', 'Toevoegen') + ': ' + p.title);
    if (p.available === false) btn.disabled = true;
    return node;
  }

  /* Pijlen links en rechts (alleen desktop, via CSS), verborgen aan het begin en eind van de carrousel. */
  function arrows(el) {
    var list = el.querySelector('.kb-recs__list');
    var track = list.parentNode.classList.contains('kb-recs__track') ? list.parentNode : null;
    if (!track) {
      track = document.createElement('div'); track.className = 'kb-recs__track';
      list.parentNode.insertBefore(track, list); track.appendChild(list);
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'kb-recs__nav kb-recs__nav--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? str('prev', 'Vorige') : str('next', 'Volgende'));
        b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'm15 6-6 6 6 6' : 'm9 6 6 6-6 6') + '"/></svg>';
        b.addEventListener('click', function () { list.scrollBy({ left: (dir === 'prev' ? -1 : 1) * list.clientWidth * 0.9, behavior: 'smooth' }); });
        track.appendChild(b);
      });
      list.addEventListener('scroll', function () { update(); }, { passive: true });
    }
    function update() {
      var prev = track.querySelector('.kb-recs__nav--prev'), next = track.querySelector('.kb-recs__nav--next');
      prev.hidden = list.scrollLeft <= 4;
      next.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    }
    requestAnimationFrame(update);
  }

  function render(el, data) {
    var list = el.querySelector('.kb-recs__list');
    list.innerHTML = '';
    if (!data || !data.products || !data.products.length) { el.hidden = true; el.dispatchEvent(new CustomEvent('kb:empty')); return; }
    var titleOverride = el.getAttribute('data-kb-title');
    var title = titleOverride || data.title || '';
    if (C.product && title.indexOf('{product}') >= 0) title = title.replace('{product}', document.title.split(/[|–-]/)[0].trim());
    if (C.collection && title.indexOf('{collection}') >= 0) title = title.replace('{collection}', C.collectionTitle || C.collection.replace(/-/g, ' '));
    var tEl = el.querySelector('.kb-recs__title');
    if (tEl) tEl.textContent = title;
    var sub = el.querySelector('.kb-recs__subtitle');
    var subText = el.getAttribute('data-kb-sub') || data.subtitle || '';
    if (sub) { sub.textContent = subText; sub.hidden = !subText; }
    var all = el.querySelector('.kb-recs__all');
    if (all) { var href = el.getAttribute('data-kb-all'); all.hidden = !href; if (href) all.href = href; }

    var mini = el.getAttribute('data-kb-placement') === 'cart_upsell';
    if (mini) el.classList.add('kb-recs--mini');
    data.products.forEach(function (p, i) {
      var node = fill(tpl.content.cloneNode(true), p);
      node.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { click(data, p, i + 1); }); });
      var btn = node.querySelector('.kbr-card__add');
      if (mini) btn.textContent = '+';
      btn.addEventListener('click', function () { click(data, p, i + 1); quickAdd(p, btn, data, mini); });
      list.appendChild(node);
    });
    if (!mini && el.getAttribute('data-kb-layout') !== 'grid') arrows(el);
    el.hidden = false;
    observeImpression(el, data);
    el.dispatchEvent(new CustomEvent('kb:rendered', { detail: data }));
  }

  function sized(url, w) {
    // Shopify CDN: voeg _400x toe voor de kaartfoto; andere hosts ongewijzigd.
    if (/cdn\.shopify\.com/.test(url)) return url.replace(/(\.[a-z]{3,4})(\?.*)?$/i, '_' + w + 'x$1$2');
    return url;
  }

  /* A/B-test: het antwoord van /recs draagt experiment: { id, variant } als er een lopende test op de plaatsing is.
     De variant gaat mee met de impressie en de klik van dat blok, zodat job 11 per variant kan tellen. */
  function withVariant(ev, data) {
    if (data.experiment && data.experiment.variant) ev.variant = data.experiment.variant;
    return ev;
  }

  function click(data, p, position) {
    if (!window.KBTrack || data.fallback) return;
    window.KBTrack.track(withVariant({ type: 'click', placement: data.placement, product_id: p.id, position: position, request_id: data.request_id }, data));
    window.KBTrack.flush();
  }

  // Eén impressie per element per antwoord (request_id): een tab of maand die wisselt, telt opnieuw.
  function observeImpression(el, data) {
    if (!window.KBTrack || data.fallback || !('IntersectionObserver' in window)) return;
    if (el.__kbSeen === data.request_id) return;
    if (el.__kbIo) el.__kbIo.disconnect();
    var io = el.__kbIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.intersectionRatio >= 0.5 && el.__kbSeen !== data.request_id) {
          el.__kbSeen = data.request_id;
          io.disconnect();
          window.KBTrack.track(withVariant({ type: 'impression', placement: data.placement, request_id: data.request_id, extra: { product_ids: data.products.map(function (p) { return p.id; }) } }, data));
        }
      });
    }, { threshold: [0.5] });
    io.observe(el);
  }

  /* Quick add: eerste beschikbare variant via /products/handle.js, dan /cart/add.js; Blockshop hoort theme:cart:productAdded te vuren.
     Wij vuren hem zelf als het theme dat niet doet, met kb_placement zodat het cart-event de bron kent. */
  function quickAdd(p, btn, data, mini) {
    btn.disabled = true;
    fetch(prefix() + '/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (prod) {
        var v = (window.KBPickVariant || (function (prod) { var vs = (prod.variants || []).filter(function (x) { return x.available; }); vs.sort(function (a, b) { return (b.price || 0) - (a.price || 0); }); return vs[0]; }))(prod);
        if (!v) throw new Error('uitverkocht');
        // Blockshop: via de eigen Cart-klasse toevoegen, dan ververst het theme de drawer, de teller en de verzendbalk.
        var BS = window.customElements && customElements.get('cart-element');
        if (BS && typeof BS.addItems === 'function' && BS.sections) {
          return BS.addItems({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: BS.sections }) }, mini ? null : btn);
        }
        return fetch(prefix() + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      })
      .then(function () {
        var li = btn.closest('.kbr-card');
        btn.textContent = mini ? '✓' : str('added', 'Toegevoegd') + ' ✓'; btn.className += ' kbr-card__add--done';
        if (li) li.classList.add('kbr-card--added');
        document.dispatchEvent(new CustomEvent('theme:cart:productAdded', { detail: { product_id: p.id, kb_placement: data.placement, kb_request_id: data.request_id } }));
        setTimeout(function () {
          if (mini && li) { li.classList.add('kbr-card--gone'); return; }
          btn.disabled = false; btn.textContent = str('add', 'Toevoegen'); btn.className = btn.className.replace(' kbr-card__add--done', '');
          if (li) li.classList.remove('kbr-card--added');
        }, 2000);
      })
      .catch(function () { btn.disabled = false; });
  }

  /* Drawer-upsell: element [data-kb-placement="cart_upsell"] in de drawer, ververst bij elke cartwijziging. */
  function loadCartUpsell() {
    var el = document.querySelector('[data-kb-placement="cart_upsell"]');
    if (!el) return;
    var cart = (window.KBTrack ? window.KBTrack.cart() : C.cart) || [];
    if (!cart.length) { el.hidden = true; return; }
    var vis = window.KBTrack ? window.KBTrack.visitor() : null;
    fetchTimeout(C.api + '/recs/cart?items=' + cart.map(function (i) { return i.product_id; }).join(',') + '&locale=' + C.locale + (vis ? '&visitor=' + vis : ''), TIMEOUT)
      .then(function (d) { render(el, d); summaryHeight(el); }).catch(function () { el.hidden = true; summaryHeight(el); });
  }
  // Vastgepind in de vaste balk met het subtotaal: Blockshop meet die balk (--summary-height) alleen bij cartwijzigingen,
  // dus na het (ver)laden van het blok opnieuw meten, anders valt het laatste product achter de balk.
  function summaryHeight(el) {
    var ce = el.closest('cart-element');
    if (ce && typeof ce.updateSummaryHeight === 'function') requestAnimationFrame(function () { ce.updateSummaryHeight(); });
  }

  function init() {
    tpl = document.getElementById('kbr-card-template');
    skel = document.getElementById('kb-skeleton-template');
    if (!tpl) return;
    document.querySelectorAll('[data-kb-placement]').forEach(function (el) {
      if (el.getAttribute('data-kb-placement') === 'cart_upsell' || el.hasAttribute('data-kb-managed')) return;
      load(el);
    });
    loadCartUpsell();
  }
  document.addEventListener('kb:cart', loadCartUpsell);
  // Blockshop vuurt zijn events op window, niet op document. theme:cart:updated komt na het vervangen van de drawer-inhoud.
  window.addEventListener('theme:cart:updated', function () { setTimeout(loadCartUpsell, 50); });

  // Wachten op kb-track (consent bekend), maar nooit langer dan 1 s: zonder consent laden we niet-persoonlijk.
  var done = false;
  function go() { if (done) return; done = true; init(); }
  document.addEventListener('kb:ready', go);
  if (window.KBTrack && window.KBTrack.consent() !== null) go();
  setTimeout(go, 1000);
  // Theme-editor: een sectie die Tamar aanzet of toevoegt wordt live ingevoegd zonder herlaad. Dan opnieuw laden
  // binnen die sectie, anders blijft het blok leeg en lijkt het kapot (12 oktober 2026).
  document.addEventListener('shopify:section:load', function (e) {
    if (!done || !e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-kb-placement]').forEach(function (el) {
      if (el.getAttribute('data-kb-placement') === 'cart_upsell' || el.hasAttribute('data-kb-managed')) return;
      load(el);
    });
  });
  // "Wissen" bij recent bekeken (data-kb-clear op de link in de kop).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-kb-clear]');
    if (!a) return;
    e.preventDefault();
    try { localStorage.setItem('kb_recent_cleared', '1'); localStorage.removeItem('kb_recent'); } catch (err) {}
    var box = a.closest('[data-kb-placement]'); if (box) box.hidden = true;
  });
  window.KBRecs = { reload: init, load: load, fill: fill, render: render, click: click, quickAdd: quickAdd, money: money, fetch: fetchTimeout, sized: sized };
})();
